import * as React from "react";
import { useTranslation } from "react-i18next";
import HoverForHelp from "components/common/HoverForHelp";
const SharingDisabledPopover = ({ type, description = void 0 }) => {
  const { t } = useTranslation("users");
  const getReadableType = (_type) => _type.replaceAll("_", " ");
  return /* @__PURE__ */ React.createElement(HoverForHelp, { title: t("permissions.sharing_disabled.title"), pullRight: false }, description || t("permissions.sharing_disabled.owners_only", { type: getReadableType(type) }));
};
export default SharingDisabledPopover;
